var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.238,
    height: 69.656,
    viewBox: "0 0 61.238 69.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12097",
    "data-name": "Trac\\xE9 12097",
    d: "M-162.833,16.667q0,27.377,0,54.755c0,1.493.376,1.863,1.876,1.872a71.127,71.127,0,0,1,13.274,1.226,62.46,62.46,0,0,1,14.95,5.2,65.454,65.454,0,0,0,29.19,6.6c1.6-.015,1.947-.347,1.947-1.961q0-33.847,0-67.693Z",
    transform: "translate(162.833 -16.667)",
    fill: "#ec6321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.9a226334888ca25891fb767f41ef96a9.svg";
export { ForwardRef as ReactComponent };